// extracted by mini-css-extract-plugin
export default {"l":"_6fc05324dc"};